import Cookies from "js-cookie";

import { restRpc, transportEvents, xHeaders } from "~/http";

namespace UserLead {
  export const queryKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_adid",
  ] as const;

  export function init() {
    restRpc.fetchUserLead();

    transportEvents.on("beforeRequest", ({ options }) => {
      options.headers[xHeaders.userLead] = Cookies.get(xHeaders.userLead)!;
    });

    const searchParams = new URLSearchParams(window.location.search);

    for (const key of queryKeys) {
      const value = searchParams.get(key);
      if (value) Cookies.set(`userLead-${key}`, value);
    }
  }

  export const introPromoEligible = () =>
    ["influencer", "partner", "podcast"].includes(
      new URLSearchParams(window.location.search).get("utm_medium")!
    );

  export const matches = (() => {
    const matchers = {
      autoLoanCampaign: () =>
        Cookies.get("userLead-utm_content") === "120236020950910338",
    };

    return (key: keyof typeof matchers) => matchers[key]();
  })();
}

export default UserLead;
